import styled from 'styled-components';
import { MOBILE_MEDIA, DESKTOP_MEDIA } from '@/constants/breakpoints';
import { useTranslation } from 'react-i18next';

const StyledText = styled.p`
  color: ${(props) => props.color};
  font-size: ${(props) => props.size};
  font-weight: ${(props) => props.weight};
  font-style: ${(props) => props.fontStyle};
  margin-top: ${(props) => props.mt};
  margin-bottom: ${(props) => props.mb};
  margin-left: ${(props) => props.ml};
  margin-right: ${(props) => props.mr};
  width: ${(props) => props.width};
  text-align: ${(props) => props.textAlign};
  white-space: ${(props) => (props.truncate ? 'nowrap' : props.preLine ? 'pre-line' : 'normal')};
  overflow: ${(props) => (props.truncate ? 'hidden' : 'visible')};
  text-overflow: ${(props) => (props.truncate ? 'ellipsis' : 'clip')};
  background: ${({ bg }) => bg};
  display: ${({ display }) => display || 'block'};
  border: ${({ border }) => border || 'none'};

  /* preLine (usado por ej. para la fecha en las tablas de documentos):
     en mobile/tablet se mantienen los \n como saltos de línea reales
     (varias líneas apiladas, para no desbordar la columna angosta);
     desde desktop (>=992px) hay espacio de sobra, así que los \n se
     colapsan a un solo espacio y todo queda en una sola línea. */
  @media ${DESKTOP_MEDIA} {
    ${(props) => (props.preLine ? 'white-space: normal;' : '')}
  }

  /* sm = layout mobile completo (teléfonos y tablets en vertical, ver
     constants/breakpoints.js), no solo hasta 575px. md/lg siguen acotando
     rangos más específicos y, al ir después, pueden afinar sobre sm. */
  @media ${MOBILE_MEDIA} {
    ${({ sm }) => sm}
  }

  @media (min-width: 576px) and (max-width: 767px) {
    ${({ md }) => md}
  }

  @media (min-width: 768px) and (max-width: 991px) {
    ${({ lg }) => lg}
  }

  /* xl = laptops/tablets horizontales de 992 a 1199px; una pantalla vertical
     de hasta 1100px ya es layout mobile, así que no entra aquí. */
  @media (min-width: 1101px) and (max-width: 1199px), (min-width: 992px) and (max-width: 1199px) and (orientation: landscape) {
    ${({ xl }) => xl}
  }

  @media (min-width: 1200px) {
    ${({ xxl }) => xxl}
  }

  @media (min-width: 1400px) {
    ${({ bigger }) => bigger}
  }
`;

const Text = ({
  color = '#ffffff',
  size = '16px',
  weight = 'ligth',
  fontStyle = 'normal',
  mt = '0px',
  mb = '0px',
  ml = '0px',
  mr = '0px',
  clave = '',
  width = 'fit-content',
  textAlign = 'left',
  truncate = false,
  preLine = false,
  bg = 'none',
  border,
  display,
  sm
}) => {
  const { t } = useTranslation();

  return (
    <StyledText
      color={color}
      size={size}
      weight={weight}
      fontStyle={fontStyle}
      mt={mt}
      mb={mb}
      ml={ml}
      mr={mr}
      width={width}
      textAlign={textAlign}
      truncate={truncate}
      preLine={preLine}
      bg={bg}
      sm={sm}
      border={border}
      display={display}
    >
      {t(clave)}
    </StyledText>
  );
};

export default Text;
